// Progress bar

export function progressBar() {
  document.addEventListener("DOMContentLoaded", function () {
    function updateProgressBar() {
      const scrollTop = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const viewportHeight = window.innerHeight;
      const scrollableHeight = documentHeight - viewportHeight;
      const scrollPercent = (scrollTop / scrollableHeight) * 100;

      const progressBar = document.querySelector("#js-progressbar");
      if (progressBar) {
        progressBar.value = scrollPercent;
      }
    }

    window.addEventListener("scroll", updateProgressBar);
    window.addEventListener("resize", updateProgressBar);

    updateProgressBar();
  });
}
